
const translations = {
  // Navigation
  "nav.about": "About Us",
  "nav.business": "Business",
  "nav.recruitment": "Recruitment",
  "nav.contact": "Contact",

  // Hero Section
  "hero.title1": "High-Quality Textile Materials",
  "hero.title2": "From Japan to the World",
  "hero.subtitle1": "Since 2006, with reliable quality and trust",
  "hero.subtitle2": "Direct business with global brands",
  "hero.cta": "View Our Business",

  // About Section
  "about.label": "About Us",
  "about.title": "Company Profile",
  "about.description1": "SECOND CO., LTD was established in 2006 as a company specializing in the export of textile materials. Since our founding, we have built trusted relationships with overseas customers through the provision of high-quality products and services.",
  "about.description2": "We focus on textile materials and yarn products, working with our customers on planning and development, achieving 100% overseas exports. Our strength lies in direct business with brands in Europe, particularly in Italy and France.",
  "about.description3": "We have established a high-quality and stable supply system, with full compliance with traceability and quality-related documentation, ensuring our customers can use our services with confidence.",
  "about.companyName": "Company Name",
  "about.companyNameValue": "SECOND CO., LTD",
  "about.englishName": "English Name",
  "about.englishNameValue": "SECOND CO., LTD",
  "about.established": "Established",
  "about.establishedValue": "November 17, 2006",
  "about.representative": "Representative",
  "about.representativeValue": "CEO Hiromi Nonogaki",
  "about.capital": "Capital",
  "about.capitalValue": "8 Million Yen",
  "about.employees": "Employees",
  "about.employeesValue": "4",
  "about.address": "Address",
  "about.addressValue1": "2-7-14 Omiya, Ichinomiya City,",
  "about.addressValue2": "Aichi Prefecture, Japan",
  "about.phone": "Phone",
  "about.phoneValue": "+81-586-25-4180",

  // Business Section
  "business.label": "Business",
  "business.title": "Our Business",
  "business.planning.title": "Material Planning & Sales",
  "business.planning.description": "From planning to sales of various yarns and materials, we provide proposals tailored to customer needs. We specialize in planning, presenting, and selling textile materials to the European market.",
  "business.export.title": "Export Operations",
  "business.export.description": "100% overseas export, with a stable supply system mainly to Europe (Italy, France). We achieve direct business with brands.",
  "business.quality.title": "Quality Control",
  "business.quality.description": "Full compliance with traceability and quality-related documentation. We maintain a thorough quality control system to deliver high-quality products with confidence.",

  // Recruitment Section
  "recruitment.label": "Recruitment",
  "recruitment.title": "Careers",
  "recruitment.subtitle": "Join our team",
  "recruitment.position": "Export & Trade Operations",
  "recruitment.jobTitle": "Position",
  "recruitment.jobTitleValue": "Export Operations, Trade Administration",
  "recruitment.employmentType": "Employment Type",
  "recruitment.employmentTypeValue": "Full-time or Part-time",
  "recruitment.workingHours": "Working Hours",
  "recruitment.workingHoursValue": "10:00 - 18:00",
  "recruitment.location": "Location",
  "recruitment.locationValue": "2-7-14 Omiya, Ichinomiya, Aichi, Japan",
  "recruitment.howToApply": "How to Apply",
  "recruitment.howToApplyValue": "Please contact us by email",
  "recruitment.atmosphere": "Work Environment",
  "recruitment.atmosphere1": "A workplace where many women are active",
  "recruitment.atmosphere2": "Dress code is flexible (as long as it is neat)",
  "recruitment.atmosphere3": "Relaxed working hours starting at 10:00 AM",

  // Contact Section
  "contact.label": "Contact",
  "contact.title": "Contact Us",
  "contact.company": "Company Name",
  "contact.name": "Your Name",
  "contact.email": "Email Address",
  "contact.message": "Message",
  "contact.submit": "Send Message",
  "contact.submitting": "Sending...",
  "contact.success": "Thank you for your inquiry. We have received your message.",
  "contact.error": "Failed to send. Please try again.",
  "contact.characters": "characters",

  // Footer
  "footer.companyInfo": "Company Info",
  "footer.contact": "Contact",
  "footer.businessHours": "Business Hours",
  "footer.weekday": "Weekdays 10:00-18:00",
  "footer.holiday": "Closed on weekends and holidays",
  "footer.description": "SECOND CO., LTD\nDelivering premium textile\nmaterials to the world",
  "footer.copyright": "© 2006-2025 SECOND CO., LTD. All rights reserved."
};

export default translations;
